import { LfMessageToastTypes, LfToastMessage } from '@lf-web-components/lf-message-toast';
import { LOCALIZED_STRINGS } from '../locale/FileSet.en';
import { FileSetEntryViewModel, InitErrors } from './fs.model';
import { format } from 'date-fns';

export function parseDate(dateTime: string | undefined | null): string {
  let parseDate = "";
  if (dateTime) {
    try {
      const date = new Date(dateTime);
      parseDate = format(date, "yyyy-MM-dd hh:mm:ss a");
    } catch (e) {
      parseDate = "";
    }
  }
  return parseDate;
}

export function lfFilesetLocalize(key: string): string {
  return LOCALIZED_STRINGS[key];
}

export function isGuid(input: string): boolean {
  return input && /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(input);
}

export function formatFileSize(bytes: number) {
  let u, b=bytes, t= 1024;     
  ['', 'K', ...'MGTPEZY'].find(x=> (u=x, b/=t, b**2<1));
  return `${u ? (t*b).toFixed(2) : bytes} ${u}B`;    
}

export function coerceStrToBoolean(input: boolean | string){
  if (typeof input === "string") {
    return input.toLocaleLowerCase() === 'true';
  }

  return input;
}

export function generateToast(type: LfMessageToastTypes, message: string) {
  const toast = new LfToastMessage();

  toast.message = message;
  toast.type = type;
  switch (type) {
    case LfMessageToastTypes.Informational:
    case LfMessageToastTypes.Validation:
      toast.timeToShow = 5000; // show toast for 5 seconds
      break;
    case LfMessageToastTypes.Warning:
    case LfMessageToastTypes.Error:
    default:
      toast.timeToShow = -1; // show toast indefinitely, or until closed
      break;
  }

  return toast;
}

export function generateStateModel(items: FileSetEntryViewModel[]) {
  return items.map(item=>({
    FileId: item.id,
    FileStateValues: [
      {StateKey: 'status', Value: item.status}, 
      {StateKey: 'type', Value: item.docType}, 
      {StateKey: 'importorigin', value: item.importOrigin}
    ]
  }));

}

export function isFileSetValid(initError: InitErrors): boolean {
  switch (initError) {
    case InitErrors.NONE_INITIALIZED:
    case InitErrors.RESOURCE_NOT_FOUND:
      return false;
    case InitErrors.NONE:
    case InitErrors.REJECT_PUBLIC_USERS:
    case InitErrors.RESOURCE_DELETED:
    default:
      return true;
  }
}

export function decodeHtmlEntities(str: string): string {
  const entities = [
    ['amp', '&'],
    ['apos', "'"],
    ['lt', '<'],
    ['gt', '>'],
    ['nbsp', ' '],
    ['#39', "'"]
    // Add more entities as needed
  ];

  for (const [entity, character] of entities) {
    const regex = new RegExp(`&${entity};`, 'g');
    str = str.replace(regex, character);
  }

  return str;
}


export function prepareFallbackId(id: string): number
{
  // id is of the format "Guid+Int", e.g. "7d96e256-a3db-11eb-b7c2-069a6ca60c8d+42364"
  let idArr = id.split('+');
  if (idArr.length > 1) {
    return parseInt(idArr[1]);
  }
  return 0;
}